import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// Asegúrate de que el elemento root esté presente
const container = document.getElementById('root');

// Verifica que el container no sea nulo antes de crear el root
if (container) {
  const root = ReactDOM.createRoot(container as HTMLElement);

  root.render(
    <StrictMode>
      {/* Puedes agregar ColorModeScript si estás utilizando el soporte de modos de color */}
      <ColorModeScript />
      <App />
    </StrictMode>
  );
}

// Si deseas que tu app funcione offline y cargue más rápido,
// puedes cambiar unregister() a register().
// Más info: https://cra.link/PWA
serviceWorker.unregister();

// Si deseas empezar a medir el rendimiento de tu app, pasa una función
// para registrar resultados (por ejemplo: reportWebVitals(console.log))
// o envía los resultados a un endpoint de análisis. Más info: https://bit.ly/CRA-vitals
reportWebVitals();
